"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonUploadItemsList = void 0;
const React = require("react");
const BronsonUploadItemsList = ({ itemList, additionalClassItemListContainer, }) => {
    const getIconProgress = (item) => {
        if (item.success)
            return 'c-icon--[semantic-checkmark]  u-text-success';
        else if (item.error)
            return 'c-icon--[info-circle]  u-text-alert';
        else
            return '';
    };
    const getProgressBar = (item) => {
        if (item.success)
            return 'is-success';
        else if (item.loading)
            return 'is-loading';
        else
            return 'is-error';
    };
    const items = () => {
        return itemList.map((item, index) => {
            return (React.createElement("div", { key: index, className: `c-upload-container__item  ${item.additionalClassItemContainer
                    ? item.additionalClassItemContainer
                    : ''}` },
                React.createElement("div", { className: `c-upload-item  ${item.additionalClass ? item.additionalClass : ''}` },
                    React.createElement("i", { className: `c-upload-item__icon  c-icon  c-icon--[${item.icon}]`, "aria-hidden": 'true', role: 'img' }),
                    React.createElement("div", { className: 'c-upload-item__content' },
                        React.createElement("div", { className: 'c-upload-item__title-row' },
                            React.createElement("p", { className: 'c-upload-item__title' }, item.fileName),
                            React.createElement("div", { className: 'c-upload-item__interaction-icons' },
                                item.showFirstOption ? (React.createElement("button", { id: item.idFirstAction ||
                                        'first-action', onClick: item.actionFirstBtn, className: 'c-upload-item__interaction-icon  \n                                            c-upload-item__interaction-icon--main' })) : (React.createElement(React.Fragment, null)),
                                item.showSecondOption ? (React.createElement("button", { id: item.idSecondAction ||
                                        'second-action', onClick: item.actionSecondBtn, className: 'c-upload-item__interaction-icon  \n                                            c-upload-item__interaction-icon--secondary' })) : (React.createElement(React.Fragment, null)),
                                item.displayProgress && (React.createElement("i", { className: `c-icon  c-icon--small  ${getIconProgress(item)}` })))),
                        item.displayProgress && (React.createElement("progress", { className: `c-progress  ${getProgressBar(item)}`, value: item.progressValue, max: '100' })),
                        React.createElement("p", { className: 'c-upload-item__subtitle-row' },
                            React.createElement("span", { className: 'c-upload-item__filesize' }, item.fileSize),
                            React.createElement("span", { className: 'c-upload-item__message' }, item.additionalMessage))))));
        });
    };
    return (React.createElement("div", { className: `c-upload-container__itemlist  ${additionalClassItemListContainer
            ? additionalClassItemListContainer
            : ''}` }, items()));
};
exports.BronsonUploadItemsList = BronsonUploadItemsList;
